/**
 * 校验表单年份和期次
 */
export default {
  data() {
    return {
      rules: {
        year: [{
          validator: false,
          trigger: 'blur',
        }],
        period: [{
          validator: false,
          trigger: 'blur',
          type: 'number'
        }]
      }
    }
  },
  methods: {
    setValid(valid) {
      if (valid) {
        this.rules.year[0].validator = (rule, value, callback) => {
          if (value && !this.searchParam.period) {
            this.$refs.searchForm.validateField('period');
            callback();
          } else if (!value && this.searchParam.period) {
            callback(new Error('"年份"为必填项'));
          } else if (!value && !this.searchParam.period) {
            this.$refs.searchForm.clearValidate();
            callback()
          } else {
            callback()
          }
        }
        this.rules.period[0].validator = (rule, value, callback) => {
          if (value && !this.searchParam.year) {
            this.$refs.searchForm.validateField('year');
            callback();
          } else if (!value && this.searchParam.year) {
            callback(new Error('"期次"为必填项'));
          } else if (!value && !this.searchParam.year) {
            this.$refs.searchForm.clearValidate();
            callback()
          } else {
            callback()
          }
        }
      } else {
        this.rules.year[0].validator = false;
        this.rules.period[0].validator = false;
      }
    },
  },
}